import {
  GridToolbarContainer,
  GridToolbarProps,
  ToolbarPropsOverrides,
} from '@mui/x-data-grid-pro'
import { Button } from '@mui/material'
import { AddCircle } from '@mui/icons-material'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useParams } from 'react-router-dom'

export function EditToolbar(props: GridToolbarProps & ToolbarPropsOverrides) {
  const { add, setLoadingDialog, title } = props
  const { loginConfig } = useUserContext()
  const { study_id } = useParams()
  return (
    <GridToolbarContainer sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant={'outlined'}
        endIcon={<AddCircle />}
        onClick={() => {
          if (setLoadingDialog) {
            setLoadingDialog(true)
          }
          add()
        }}
        disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
      >
        {title}
      </Button>
    </GridToolbarContainer>
  )
}
